import React from 'react'

import Section from '../../../../../../components/Section'
import { Purchase, PaymentInfo } from '../../../types'

import { CurrencyList } from '../../../../Plans/Positions/Edit/types'

import Checkbox from '../../../../../../components/form/Checkbox'
import CurrencySelector from '../../../../../../components/currency/CurrencySelector'

const formatDate = (value: string | null | undefined) => {
    if (!value) {
        return {
            date: '',
        }
    }

    const date = new Date(value)

    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return {
        date: `${year}-${month}-${day}`,
    }
}

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseGuid: string | undefined
    purchasesLoading: boolean
    purchasesError: string | null
    purchase: Purchase
    currencyData: CurrencyList[]
    onPayment: (payment: PaymentInfo | boolean) => void
    onCurrencyChange: (value: number) => void
    onPaymentSum: (value: number) => void
}

const PurchaseDocumentationDelivery: React.FC<Props> = (props) => {
    return (
        <Section title="Предоставление документации">
            <fieldset disabled={props.purchaseAction}>
                <div className="flex flex-col w-full gap-3">
                    <div className="flex flex-row w-full gap-x-5 items-start justify-start">
                        <div className="flex flex-row w-full gap-x-2 items-end justify-start">
                            <div className="flex flex-col w-[200px]">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Срок предоставления{' '}
                                    <span className="text-[#FF0000]">*</span>
                                </label>
                                <input
                                    type="date"
                                    className={`form-input user-input-placeholder w-full`}
                                    value={
                                        formatDate(
                                            props.purchase
                                                ?.delivery_start_date_time
                                        ).date ?? ''
                                    }
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                />
                            </div>
                            <div className="h-[28px] text-sm text-[#6A6A6A] dark:text-[#8A8A8A] items-center justify-center">
                                -
                            </div>
                            <div className="flex flex-col w-[200px]">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    {' '}
                                </label>
                                <input
                                    type="date"
                                    className={`form-input user-input-placeholder w-full`}
                                    value={
                                        formatDate(
                                            props.purchase
                                                ?.delivery_end_date_time
                                        ).date ?? ''
                                    }
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Место предоставления{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <textarea
                            className={`form-textarea w-full`}
                            maxLength={2000}
                            rows={3}
                            value={props.purchase?.place || ''}
                        />
                    </div>

                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Порядок предоставления{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <textarea
                            className={`form-textarea w-full`}
                            maxLength={2000}
                            rows={3}
                            value={props.purchase?.procedure || ''}
                        />
                    </div>

                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Официальный сайт ЕИС, на котором размещена
                            документация{' '}
                        </label>
                        <input
                            type="text"
                            className={`form-input user-input-placeholder w-[200px]`}
                            value={'www.zakupki.gov.ru'}
                            readOnly
                        />
                    </div>

                    <div className="flex flex-col w-fit gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Установлена плата за предоставление документации"
                                checked={props.purchase.payment ? true : false}
                                onChange={props.onPayment}
                                disabled={false}
                            />
                        </div>
                    </div>

                    {props.purchase.payment ? (
                        <>
                            <div className="flex flex-row w-full gap-x-5 items-start justify-start">
                                <div className="flex flex-col items-start justify-start w-[200px]">
                                    <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                        Размер платы{' '}
                                        <span className="text-[#FF0000]">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-input user-input-placeholder`}
                                        value={props.purchase.payment.sum}
                                        onChange={(e) =>
                                            props.onPaymentSum(
                                                Number(e.target.value)
                                            )
                                        }
                                    />
                                </div>
                                <div className="flex flex-col w-[200px]">
                                    <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                        Валюта{' '}
                                        <span className="text-[#FF0000]">
                                            *
                                        </span>
                                    </label>
                                    <select
                                        className="form-select h-full"
                                        onChange={(e) => Number(e.target.value)}
                                        value={Number(
                                            props.purchase.payment.currency
                                                .digital_code
                                        )}
                                    >
                                        {props.currencyData.map((currency) => (
                                            <option
                                                key={currency.num_code}
                                                value={currency.num_code}
                                            >
                                                {currency.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="flex flex-col w-full items-start justify-start ">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Срок и порядок внесения платы за
                                    документацию{' '}
                                    <span className="text-[#FF0000]">*</span>
                                </label>
                                <textarea
                                    className={`form-textarea w-full`}
                                    maxLength={2000}
                                    rows={3}
                                    value={
                                        props.purchase.payment.procedure || ''
                                    }
                                />
                            </div>
                        </>
                    ) : (
                        ''
                    )}
                </div>
            </fieldset>
        </Section>
    )
}

export default PurchaseDocumentationDelivery
